module.exports = "/public/assets/partner_background.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/app/img/partner_background.jpeg
// module id = 2744
// module chunks = 0